import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  APPOINTMENT_BOOK_NEXT_AODTH_FORM_PATH,
  APPOINTMENT_BOOK_NEXT_AODTH_NOTICE_PATH,
  APPOINTMENT_BOOK_NEXT_CONFIRM_PATH,
  APPOINTMENT_BOOK_NEXT_FORM_PATH,
  APPOINTMENT_BOOK_NEXT_FORM_SUCCESS_PATH,
  APPOINTMENT_BOOK_NEXT_PATH,
  APPOINTMENT_BOOK_NEXT_SUCCESS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const BookNextAodthFormPage = lazy(() => import('./pages/BookNextAodthFormPage/BookNextAodthFormPage'));
const BookNextAodthNoticePage = lazy(() => import('./pages/BookNextAodthNoticePage/BookNextAodthNoticePage'));
const BookNextAvailableSlotSelectionPage = lazy(
  () => import('./pages/BookNextAvailableSlotSelectionPage/BookNextAvailableSlotSelectionPage')
);
const BookNextSuccessPage = lazy(() => import('./pages/BookNextSuccessPage/BookNextSuccessPage'));
const BookNextRequestFormPage = lazy(() => import('./pages/BookNextRequestFormPage/BookNextRequestFormPage'));
const BookNextRequestFormSuccessPage = lazy(
  () => import('./pages/BookNextRequestFormSuccessPage/BookNextRequestFormSuccessPage')
);
const BookNextSlotConfirmationPage = lazy(
  () => import('./pages/BookNextSlotConfirmationPage/BookNextSlotConfirmationPage')
);

export const APPOINTMENT_BOOK_NEXT_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BookNextAodthNoticePage />,
    displayTitle: () => 'Next Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BOOK_NEXT_AODTH_NOTICE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BookNextAodthFormPage />,
    displayTitle: () => 'Next Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BOOK_NEXT_AODTH_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BookNextAvailableSlotSelectionPage />,
    displayTitle: () => 'Next Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BOOK_NEXT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BookNextSuccessPage />,
    displayTitle: () => 'Next Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BOOK_NEXT_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BookNextRequestFormPage />,
    displayTitle: () => 'Next Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BOOK_NEXT_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BookNextRequestFormSuccessPage />,
    displayTitle: () => 'Next Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BOOK_NEXT_FORM_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <BookNextSlotConfirmationPage />,
    displayTitle: () => 'Next Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_BOOK_NEXT_CONFIRM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
];
